<template>
  <div>
    <b-row id="g-main-image" class="mb-5">
      <b-col sm="2">
        <label>
          <h5>
            {{ $t("PAGE.CAMPAIGN.FORM.FIELDS.POLICY") }}
          </h5>
        </label>
      </b-col>
      <b-col sm="10">
        <ckeditor
          :editor="editor"
          v-model="form.policy"
          :config="editorConfig"
        ></ckeditor>
        <p v-if="isSubmit && !form.policy" class="text-danger">
          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
        </p>

        <div v-if="form.policy" class="preview mt-2">
          <b-row>
            <b-col sm="12" style="padding: 20px 20px 0px 20px">
              <b-card>
                <div v-html="form.policy"></div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col sm="2">
        <label>
          <h5>
            {{ $t("PAGE.CAMPAIGN.FORM.FIELDS.POLICY_NOT_ACCEPT") }}
          </h5>
        </label>
      </b-col>
      <b-col sm="10">
        <ckeditor
          :editor="editor"
          v-model="form.policy_not_accept"
          :config="editorConfig"
        ></ckeditor>
        <p v-if="isSubmit && !form.policy_not_accept" class="text-danger">
          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
        </p>

        <div v-if="form.policy_not_accept" class="preview mt-2">
          <b-row>
            <b-col sm="12" style="padding: 20px 20px 0px 20px">
              <b-card>
                <div v-html="form.policy_not_accept"></div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
.preview {
  min-height: 667px;
  max-width: 375px;
  border: 2px solid rgb(179, 179, 179);
  border-radius: 20px;
  padding-bottom: 20px;
}
@media only screen and (max-width: 460px) {
  .preview {
    max-width: 100%;
  }
}
.image-header {
  height: auto;
  max-height: 100px;
  width: 100%;
  border-radius: 20px 20px 0px 0px;
  object-fit: cover;
}
</style>
<script>
import { Config } from "@/core/config/variable.config";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import AutoImage from "@ckeditor/ckeditor5-image/src/autoimage";
import AutoLink from "@ckeditor/ckeditor5-link/src/autolink";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave";
import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import CloudServices from "@ckeditor/ckeditor5-cloud-services/src/cloudservices";
import Code from "@ckeditor/ckeditor5-basic-styles/src/code";
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock";
import DataFilter from "@ckeditor/ckeditor5-html-support/src/datafilter";
import DataSchema from "@ckeditor/ckeditor5-html-support/src/dataschema";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import FindAndReplace from "@ckeditor/ckeditor5-find-and-replace/src/findandreplace";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize";
import GeneralHtmlSupport from "@ckeditor/ckeditor5-html-support/src/generalhtmlsupport";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";
import HtmlComment from "@ckeditor/ckeditor5-html-support/src/htmlcomment";
import HtmlEmbed from "@ckeditor/ckeditor5-html-embed/src/htmlembed";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageInsert from "@ckeditor/ckeditor5-image/src/imageinsert";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Link from "@ckeditor/ckeditor5-link/src/link";
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage";
import List from "@ckeditor/ckeditor5-list/src/list";
import ListProperties from "@ckeditor/ckeditor5-list/src/listproperties";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import MediaEmbedToolbar from "@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar";
import Mention from "@ckeditor/ckeditor5-mention/src/mention";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat";
import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting";
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters";
import SpecialCharactersArrows from "@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows";
import SpecialCharactersCurrency from "@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency";
import SpecialCharactersEssentials from "@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials";
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin";
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical";
import SpecialCharactersText from "@ckeditor/ckeditor5-special-characters/src/specialcharacterstext";
import StandardEditingMode from "@ckeditor/ckeditor5-restricted-editing/src/standardeditingmode";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableCaption from "@ckeditor/ckeditor5-table/src/tablecaption";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import TextPartLanguage from "@ckeditor/ckeditor5-language/src/textpartlanguage";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation";
import TodoList from "@ckeditor/ckeditor5-list/src/todolist";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";
import EmojiActivity from "@/core/plugins/emoji-activity";
import EmojiFlags from "@/core/plugins/emoji-flags";
import EmojiFood from "@/core/plugins/emoji-food";
import EmojiNature from "@/core/plugins/emoji-nature";
import EmojiObjects from "@/core/plugins/emoji-objects";
import EmojiPeople from "@/core/plugins/emoji-people";
import EmojiPlaces from "@/core/plugins/emoji-places";
import EmojiSymbols from "@/core/plugins/emoji-symbols";

export default {
  name: "CampaignPolicy",
  props: ["form", "isSubmit"],
  data() {
    return {
      ADMIN_IMAGE_URL: Config.ADMIN_IMAGE_URL,
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          Base64UploadAdapter,
          BlockQuote,
          Bold,
          CloudServices,
          Code,
          CodeBlock,
          DataFilter,
          DataSchema,
          Essentials,
          FindAndReplace,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          Highlight,
          HorizontalLine,
          HtmlComment,
          HtmlEmbed,
          Image,
          ImageCaption,
          ImageInsert,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          MediaEmbedToolbar,
          Mention,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SourceEditing,
          SpecialCharacters,
          EmojiPeople,
          EmojiFood,
          EmojiPlaces,
          EmojiActivity,
          EmojiFlags,
          EmojiNature,
          EmojiObjects,
          EmojiSymbols,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          StandardEditingMode,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableProperties,
          TableToolbar,
          TextPartLanguage,
          TextTransformation,
          TodoList,
          Underline,
          WordCount
        ],

        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "underline",
            "italic",
            "strikethrough",
            "|",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "fontFamily",
            "|",
            "link",
            "imageUpload",
            "mediaEmbed",
            "insertTable",
            "specialCharacters",
            "|",
            "undo",
            "redo",
            "-",
            "horizontalLine",
            "pageBreak",
            "superscript",
            "subscript",
            "highlight",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "alignment",
            "outdent",
            "indent",
            "removeFormat",
            "blockQuote"
          ],
          shouldNotGroupWhenFull: true
        },
        language: "en",
        image: {
          toolbar: [
            "imageTextAlternative",
            "imageStyle:inline",
            "imageStyle:block",
            "imageStyle:side",
            "linkImage"
          ]
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties"
          ]
        }
      }
    };
  },
  methods: {
    previewImage(file) {
      return window.URL.createObjectURL(file);
    }
  }
};
</script>
